import { cva, type VariantProps } from "class-variance-authority";
import type { ChildrenProps, ClassNameProps } from "../types";
import { cn } from "../utils";
import { ContentBoxBreadcrumbs } from "./content-box-breadcrumbs";
import { useAppShellStore } from "./store";

/** Props Interface */
interface ContentBoxProps extends ChildrenProps, ClassNameProps, VariantProps<typeof contentBox> {
	as?: React.ElementType;
	onSubmit?: (event: React.FormEvent) => void;
	withBreadcrumbs?: boolean;
}

export function ContentBox({
	children,
	className,
	bottomPadding = "default",
	as: Component = "div",
	onSubmit,
	withBreadcrumbs = true,
}: ContentBoxProps) {
	/** Classes */
	const appShellStore = useAppShellStore();
	const classes = contentBox({
		bottomPadding,
	});

	/** Render */
	return (
		<Component
			className={cn(classes, className)}
			onSubmit={onSubmit}
		>
			{appShellStore.layout === "sidebar" && withBreadcrumbs && <ContentBoxBreadcrumbs />}
			{children}
		</Component>
	);
}

const contentBox = cva(["flex flex-col grow-0 gap-4 px-4 w-full h-full min-h-0 relative"], {
	variants: {
		bottomPadding: {
			default: ["pb-4"],
			none: ["pb-0"],
		},
	},
});
